import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { PoolResponse } from "~types/pool";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect/InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

export const SelectPool = ({ value, ...props }: Props) => {
  const { sport, organizationId, seasonId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: PoolResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameLocal, value: x.poolCode }));

  return (
    <InfinitySelect<PoolResponse>
      {...props}
      url={`${sport}/o/${organizationId}/seasons/${seasonId}/pools`}
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.POOL}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
